'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loadable = require('UIComponents/decorators/Loadable');

var _Loadable2 = _interopRequireDefault(_Loadable);

var _LoadingState = require('../../components/LoadingState');

var _LoadingState2 = _interopRequireDefault(_LoadingState);

var _ErrorState = require('../../components/ErrorState');

var _ErrorState2 = _interopRequireDefault(_ErrorState);

var _resolveThreadedChatAreaContainer = require('../resolvers/resolveThreadedChatAreaContainer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsyncThreadedChatAreaContainer = (0, _Loadable2.default)({
  loader: _resolveThreadedChatAreaContainer.resolveThreadedChatAreaContainer,
  LoadingComponent: _LoadingState2.default,
  ErrorComponent: _ErrorState2.default
});

exports.default = AsyncThreadedChatAreaContainer;
module.exports = exports['default'];